export const LOCALSTORAGE_REHYDRATION_ACTIONS = Object.freeze({
  'order-finished-id-hash': ['order/trackPurchaseRehydrate'],
  checkout: ['checkout/rehydrate', 'ui/checkout/rehydrate'],
  'checkout-cancel': ['checkout/rehydrate', 'ui/checkout/rehydrate'],
  'checkout-error': ['checkout/rehydrate', 'ui/checkout/rehydrate'],
})
